{
  "errorScreen": {
    "unavailableTitle": "Ce canvas est indisponible",
    "privateTitle": "Ce canvas est privé ou indisponible",
    "privateMessage": "Connectez-vous pour vérifier si vous y avez accès, ou demandez à son propriétaire de le partager avec vous.",
    "logIn": "Se connecter / Créer un compte",
    "backToCanvases": "Retour à mes canvas"
  },
  "compactFrameDelete": {
    "title": "Supprimer la frame compacte ?",
    "description_one": "{{count}} node masqué à l'intérieur sera aussi supprimé. Vous pourrez annuler, ou le restaurer depuis la corbeille.",
    "description_other": "{{count}} nodes masqués à l'intérieur seront aussi supprimés. Vous pourrez annuler, ou les restaurer depuis la corbeille."
  },
  "deleteCanvas": {
    "title": "Supprimer le canvas ?",
    "description": "« {{name}} » sera supprimé définitivement, avec ses blocs et ses conversations. Cette action est irréversible."
  },
  "dropOverlay": {
    "hint": "Déposez pour créer un node"
  },
  "canvasForm": {
    "updated": "Espace de travail « {{name}} » mis à jour",
    "created": "Espace de travail « {{name}} » créé",
    "updateFailed": "Erreur lors de la mise à jour de l'espace de travail.",
    "createFailed": "Erreur lors de la création de l'espace de travail.",
    "editTitle": "Modifier l'espace de travail",
    "createTitle": "Créer un espace de travail",
    "editDescription": "Modifiez le nom, l'icône, la description et l'apparence.",
    "createDescription": "Donnez un nom à ce nouvel espace de travail.",
    "nameLabel": "Nom de l'espace de travail",
    "namePlaceholder": "Nom du canvas",
    "nameRequired": "Le nom ne peut pas être vide",
    "descriptionLabel": "Description (facultative)",
    "descriptionPlaceholder": "Description du canvas. Elle aide l'assistant à comprendre son contexte.",
    "coverTitle": "Image de couverture (facultative)",
    "coverHint": "Affichée sur la carte du canvas, sur la page d'accueil.",
    "backgroundTitle": "Fond (facultatif)",
    "resetBackground": "Rétablir le fond par défaut",
    "loadingBackground": "Chargement du fond…",
    "creating": "Création…"
  },
  "trash": {
    "title": "Corbeille",
    "description_one": "Les blocs supprimés sont conservés {{count}} jour, puis supprimés définitivement. Restaurer un bloc ramène son contenu et les connexions parties avec lui.",
    "description_other": "Les blocs supprimés sont conservés {{count}} jours, puis supprimés définitivement. Restaurer un bloc ramène son contenu et les connexions parties avec lui.",
    "empty": "La corbeille est vide.",
    "restoreFailed": "Impossible de restaurer ce bloc",
    "deleteFailed": "Impossible de supprimer ce bloc",
    "deletedAgo": "Supprimé {{ago}}",
    "deleted": "Supprimé",
    "contentGone": "contenu déjà supprimé",
    "restore": "Restaurer",
    "deleteForeverConfirm": "Supprimer définitivement ?",
    "deleteForeverContainer": "« {{title}} » et tout ce qu'il contient seront supprimés définitivement. Cette action est irréversible.",
    "deleteForeverNode": "« {{title}} » sera supprimé définitivement. Cette action est irréversible.",
    "deleteForever": "Supprimer définitivement"
  },
  "status": {
    "synced": "Synchronisé",
    "syncError": "Erreur de synchronisation"
  },
  "sharing": {
    "title": "Partager le canvas",
    "share": "Partager",
    "sharing": "Partage…",
    "nowPublic": "Le canvas est désormais public.",
    "nowPrivate": "Le canvas est désormais privé.",
    "visibilityFailed": "Impossible de modifier la visibilité du canvas",
    "linkCopied": "Lien copié dans le presse-papiers",
    "copyFailed": "Impossible de copier le lien",
    "publicLink": "Lien public",
    "publicLinkHint": "Toute personne disposant du lien peut consulter ce canvas.",
    "copyLink": "Copier le lien",
    "notReady": "Le canvas n'est pas encore prêt.",
    "viewLinkCopied": "Lien vers cette vue copié dans le presse-papiers",
    "viewLink": "Lien vers cette vue",
    "viewLinkHint": "Ouvre le canvas cadré exactement comme vous le voyez maintenant.",
    "shareFailed": "Impossible de partager le canvas",
    "emailPlaceholder": "nom@exemple.com",
    "permission": "Droits",
    "roles": {
      "viewer": "Lecteur",
      "editor": "Éditeur"
    },
    "removeFailed": "Impossible de retirer le partage",
    "sharedWith": "Partagé avec",
    "removeAccess": "Retirer l'accès"
  },
  "sandbox": {
    "title": "L'ordinateur de Nolë",
    "ariaLabel": "L'ordinateur de Nolë : {{status}}",
    "starting": "Démarrage…",
    "startingTooltip": "L'ordinateur de Nolë démarre…",
    "turningOff": "Extinction…",
    "turningOffTooltip": "L'ordinateur de Nolë s'éteint…",
    "workingForYouIn": "Travaille pour vous, dans « {{conversation}} »",
    "workingForYouVia": "Travaille pour vous, via « {{via}} »",
    "workingForYou": "Travaille pour vous",
    "workingFor": "Travaille pour {{name}}",
    "workingForSomeone": "Travaille pour quelqu'un d'autre sur ce canvas",
    "workingTooltip": "Nolë utilise son ordinateur",
    "onFor": "Allumé depuis {{since}}",
    "onTooltip": "L'ordinateur de Nolë est allumé",
    "turnOffFailed": "Impossible d'éteindre l'ordinateur de Nolë",
    "whatItIs": "Un ordinateur dans le cloud que Nolë utilise pour ce canvas : analyser des données, convertir des fichiers ou faire des calculs.",
    "lastUsed": "Utilisé pour la dernière fois {{ago}}.",
    "turnsOff": "Il s'éteint tout seul quelques minutes après que Nolë a terminé.",
    "websites": "Sites qu'il peut consulter",
    "turnOffNow": "Éteindre maintenant",
    "turnOffLater": "Vous pourrez l'éteindre quand Nolë aura fini de s'en servir. Rien n'est perdu : ses fichiers sont conservés, et il se rallume quand Nolë en a besoin.",
    "nothingLost": "Rien n'est perdu : ses fichiers sont conservés, et il se rallume quand Nolë en a besoin."
  },
  "authBanner": {
    "message": "<strong>Vous consultez un canvas public.</strong> Connectez-vous pour dupliquer, modifier et garder vos propres espaces de travail.",
    "logIn": "Se connecter<wide> / Créer un compte</wide>",
    "dismiss": "Masquer"
  },
  "taskPills": {
    "deletedNode": "Node supprimé",
    "goTo": "Aller à « {{title}} »"
  },
  "history": {
    "undoTitle": "Annuler (Ctrl+Z)",
    "redo": "Rétablir",
    "redoTitle": "Rétablir (Ctrl+Shift+Z)"
  },
  "bookmarks": {
    "title": "Favoris",
    "dangling": "Cette cible n'est plus sur le canvas",
    "nodeRowTitle": "{{label}} — clic pour y aller, {{modifier}}+clic pour l'ouvrir",
    "reorder": "Réordonner le favori",
    "remove": "Retirer le favori",
    "empty": "Aucun favori pour l'instant. Faites un clic droit sur un node, une sélection ou le canvas pour en ajouter un."
  },
  "dockList": {
    "close": "Fermer : {{title}}"
  },
  "toolbar": {
    "tool": "Outil du canvas",
    "select": "Outil de sélection",
    "selectTitle": "Sélectionner, déplacer et lasso",
    "hand": "Outil main",
    "handTitle": "Main : faites glisser pour vous déplacer sur le canvas",
    "frame": "Tracer une frame",
    "frameTitle": "Tracer une frame pour regrouper des nodes (F)",
    "addBlock": "Ajouter un bloc",
    "searchTitle": "Rechercher dans ce canvas ou aller sur un autre"
  },
  "search": {
    "description": "Recherchez parmi les nodes, les documents et le contenu du canvas.",
    "placeholderTitles": "Rechercher dans les titres — \"expression exacte\", -exclure, a OR b",
    "placeholderSemantic": "Recherche sémantique — décrivez l'idée avec vos propres mots",
    "placeholder": "Rechercher — \"expression exacte\", -exclure, a OR b",
    "clear": "Effacer la recherche",
    "hidePreview": "Masquer l'aperçu",
    "showPreview": "Afficher l'aperçu",
    "titlesOnlyHint": "Ne chercher que dans les titres",
    "keywordOnly": "Disponible uniquement en mode mots-clés",
    "titlesOnly": "Titres seuls",
    "searching": "Recherche en cours",
    "results_one": "{{count}} résultat",
    "results_other": "{{count}} résultats",
    "resultsLabel": "Résultats de recherche",
    "noResults": "Aucun résultat",
    "noMatchesFiltered": "Aucun résultat pour « {{query}} » avec ces filtres.",
    "noMatches": "Aucun résultat pour « {{query}} ».",
    "relaxed": "Aucun résultat exact — voici des résultats proches.",
    "noRecentFiltered": "Aucun node récent ne correspond à ces filtres",
    "noNodes": "Aucun node pour l'instant",
    "recent": "Récents",
    "footer": {
      "navigate": "naviguer",
      "goTo": "y aller",
      "openWindow": "ouvrir la fenêtre",
      "attach": "<kbd>Alt</kbd>+clic pour joindre à Nolë",
      "close": "fermer"
    },
    "rowDetach": "Alt+clic pour retirer de Nolë",
    "rowAttach": "Alt+clic pour joindre à Nolë"
  },
  "preview": {
    "hover": "Survolez un résultat pour en voir l'aperçu.",
    "navigate": "Aller au node",
    "openWindow": "Ouvrir dans une fenêtre",
    "edited": "Modifié {{ago}}",
    "notLoaded": "Contenu non chargé.",
    "titleOnCanvas": "Titre sur le canvas.",
    "emptyTitle": "Titre vide.",
    "none": "Pas d'aperçu pour ce node.",
    "emptyDocument": "Document vide.",
    "rows_one": "{{count}} ligne",
    "rows_other": "{{count}} lignes",
    "columns_one": "{{count}} colonne",
    "columns_other": "{{count}} colonnes",
    "noImage": "Aucune image.",
    "image": "Image",
    "noLink": "Aucun lien.",
    "noFile": "Aucun fichier.",
    "page": "Page",
    "pageNumber": "Page {{page}}",
    "noVideo": "Aucune vidéo.",
    "videoUnavailable": "Vidéo indisponible.",
    "noAudio": "Aucun audio.",
    "noValue": "Aucune valeur.",
    "yes": "Oui",
    "no": "Non",
    "emptyApp": "App vide.",
    "appSource_one": "Source · {{count}} ligne — ouvrez la fenêtre pour l'exécuter",
    "appSource_other": "Source · {{count}} lignes — ouvrez la fenêtre pour l'exécuter",
    "empty": "Vide.",
    "elements_one": "{{count}} élément",
    "elements_other": "{{count}} éléments",
    "more_one": "+{{count}} autre",
    "more_other": "+{{count}} autres",
    "unavailable": "Aperçu indisponible."
  },
  "shell": {
    "canvases": "Canvas",
    "goToCanvas": "Aller à un canvas",
    "yourCanvases": "Vos canvas",
    "noCanvas": "Aucun canvas pour l'instant",
    "sharedWithYou": "Partagés avec vous",
    "canvasActions": "Actions pour {{name}}",
    "home": "Accueil",
    "breadcrumb": "Fil d'Ariane",
    "sidePanel": "Panneau latéral",
    "resizeSidePanel": "Redimensionner le panneau latéral",
    "panels": "Panneaux du canvas"
  },
  "userCorner": {
    "account": "Votre compte",
    "aiUsage": "Consommation IA",
    "inbox": "Boîte de réception",
    "tutorials": "Tutoriels",
    "signOut": "Se déconnecter"
  },
  "dispatch": {
    "routing": "Recherche de la bonne tâche pour « {{prompt}} »",
    "routingEllipsis": "Recherche de la bonne tâche pour « {{prompt}} »…",
    "redirectFailed": "Impossible de lancer une nouvelle tâche",
    "runInParallel": "Lancer en parallèle",
    "notice": {
      "steer": "Ajouté à « {{title}} » — Nolë en tient compte en cours de route",
      "steerUntitled": "Ajouté à une tâche précédente — Nolë en tient compte en cours de route",
      "answer": "Réponse donnée à la question de « {{title}} »",
      "answerUntitled": "Réponse donnée à la question d'une tâche précédente",
      "continue": "Suite de « {{title}} »",
      "continueUntitled": "Suite d'une tâche précédente",
      "newTask": "Nouvelle tâche lancée"
    }
  },
  "dictation": {
    "memoRecording": "Un mémo vocal est en cours d'enregistrement.",
    "sendFailed": "Impossible d'envoyer votre demande. Elle vous attend dans le panneau de Nolë."
  },
  "windowDock": {
    "openWindows": "Fenêtres ouvertes",
    "window": "Fenêtre",
    "floating": "flottante",
    "floatingTitle": "{{title}} · flottante",
    "goToNode": "Aller au node",
    "goToNodeTitle": "Aller au node sur le canvas",
    "windows": "Fenêtres",
    "resize": "Redimensionner le panneau des fenêtres",
    "collapse": "Replier le panneau des fenêtres",
    "collapseTitle": "Replier (])",
    "close": "Fermer {{title}}"
  },
  "noleRail": {
    "buttonTitle": "Nolë (N) · maintenez Alt pour parler",
    "dismissFailed": "Impossible d'écarter la tâche.",
    "pillLabel": "{{status}} : {{request}}",
    "status": {
      "running": "En cours",
      "waiting": "Attend votre réponse",
      "error": "Échec",
      "aborted": "Interrompue",
      "done": "Terminée"
    },
    "moreTasks_one": "{{count}} autre tâche",
    "moreTasks_other": "{{count}} autres tâches",
    "dictation": {
      "sending": "Envoi…",
      "handsFree": "Mains libres",
      "listening": "Nolë vous écoute",
      "lockedHint": "<kbd>Alt</kbd>/<kbd>Enter</kbd> envoie · <kbd>Esc</kbd> annule",
      "holdHint": "relâchez pour envoyer · <kbd>Esc</kbd> annule",
      "openingMic": "Ouverture du micro…",
      "speak": "Parlez, Nolë vous écoute…",
      "click": "Clic",
      "altClick": "Alt + clic",
      "toAttach": "pour joindre un node"
    }
  },
  "edgeMenu": {
    "title": "Actions de la connexion",
    "color": "Couleur",
    "thickness": "Épaisseur",
    "strokeWidth": {
      "thin": "Fine",
      "thick": "Épaisse"
    },
    "appearance": "Apparence",
    "strokeStyle": {
      "solid": "Pleine",
      "dashed": "Tirets",
      "dotted": "Pointillés"
    },
    "addPoint": "Ajouter un point",
    "removeLabel": "Retirer le libellé",
    "source": "Source",
    "target": "Cible",
    "node": "Node"
  },
  "addMenu": {
    "tabs": {
      "nodes": {
        "label": "Nodes",
        "searchPlaceholder": "Rechercher un node"
      },
      "embeds": {
        "label": "Intégrations",
        "searchPlaceholder": "Rechercher un service"
      }
    },
    "groups": {
      "text": "Texte",
      "dataApps": "Données et apps",
      "media": "Médias"
    },
    "hints": {
      "title": "Un titre pour une zone",
      "blocknote": "Un document en texte riche",
      "value": "Un texte, un nombre ou un interrupteur",
      "link": "L'aperçu d'une page web",
      "table": "Des lignes et des colonnes",
      "database": "Des fiches avec des vues",
      "board": "Un kanban de cartes",
      "app": "Une mini-app, en code",
      "image": "Importez ou collez une image",
      "file": "Un PDF, Word, Excel ou zip",
      "audio": "Un son ou un enregistrement",
      "video": "Lire un fichier vidéo"
    },
    "addRowFailed": "Impossible d'ajouter une ligne",
    "customNodes": "Custom nodes",
    "customNode": "Custom node",
    "customNodeDescription": "Custom node réutilisable",
    "databaseRows": "Lignes de base de données",
    "newRow": "Nouvelle ligne",
    "newRowDescription": "Nouvelle ligne de cette base de données",
    "services": "Services",
    "noServiceMatches": "Aucun service ne correspond à « {{query}} »",
    "noNodeMatches": "Aucun node ne correspond à « {{query}} »",
    "footer": {
      "navigate": "Naviguer"
    },
    "manageTemplates": "Gérer les modèles"
  },
  "databaseRow": {
    "detached": "Détaché de {{title}}. Il reste sur le canvas.",
    "detachedUntitled": "Détaché de la base de données. Il reste sur le canvas.",
    "detachFailed": "Impossible de détacher la ligne",
    "detachFrom": "Détacher de {{title}}",
    "detachFromUntitled": "Détacher de la base de données",
    "added": "Ajouté à {{title}}.",
    "addFailed": "Impossible d'ajouter le node",
    "addTo": "Ajouter à {{title}}"
  },
  "embedStep": {
    "empty": "Collez d'abord un lien.",
    "invalid": "Saisissez un lien valide.",
    "wrongService": "Ce lien ne semble pas être un lien {{service}}.",
    "linkLabel": "Lien {{service}}",
    "hint": "Collez le lien depuis votre navigateur ou le menu Partager."
  },
  "nodesMenu": {
    "blockActions": "Actions du bloc",
    "selectionActions": "Actions de la sélection",
    "layer": "Plan",
    "color": "Couleur",
    "editTemplate": "Modifier le modèle",
    "mergeImages_one": "Fusionner les images ({{count}})",
    "mergeImages_other": "Fusionner les images ({{count}})",
    "detachFromNole": "Retirer de Nolë",
    "attachToNole": "Joindre à Nolë",
    "altClick": "Alt + clic",
    "bookmark": "Ajouter aux favoris",
    "removeBookmarks_one": "Retirer des favoris ({{count}})",
    "removeBookmarks_other": "Retirer des favoris ({{count}})",
    "bookmarkSelection_one": "Ajouter la sélection aux favoris ({{count}})",
    "bookmarkSelection_other": "Ajouter la sélection aux favoris ({{count}})",
    "removeFromFrame": "Sortir de la frame",
    "removeFromFrameCount_one": "Sortir de la frame ({{count}})",
    "removeFromFrameCount_other": "Sortir de la frame ({{count}})",
    "moveToCanvas": "Déplacer vers un autre canvas"
  },
  "convert": {
    "extracting": "Remplissage des champs depuis la source…",
    "failed": "Impossible de convertir le node",
    "database": "Base de données",
    "title": "Convertir en custom node",
    "none": "Aucun custom node pour l'instant",
    "create": "Créer un custom node…"
  },
  "moveToCanvas": {
    "failed": "Impossible de déplacer vers ce canvas",
    "title_one": "Déplacer le node vers un autre canvas",
    "title_other": "Déplacer {{count}} nodes vers un autre canvas",
    "description": "Choisissez un canvas de destination, puis confirmez.",
    "loading": "Chargement des canvas…",
    "empty": "Aucun autre canvas disponible.",
    "moving": "Déplacement…",
    "confirm": "OK"
  },
  "canvasMenu": {
    "bookmarkHere": "Ajouter ici aux favoris"
  },
  "arrangeMenu": {
    "title": "Aligner et répartir"
  },
  "welcome": {
    "title": "Bienvenue sur Nolënor",
    "description": "Trois gestes pour bien démarrer. Le reste viendra en chemin.",
    "descriptionMobile": "Quelques infos avant de commencer.",
    "goToStep": "Aller à l'étape {{step}} : {{title}}",
    "stepOf": "Étape {{step}} sur {{total}}",
    "gotIt": "C'est compris",
    "next": "Suivant",
    "pointer": {
      "navigate": {
        "title": "Se déplacer",
        "body": "Maintenez le <strong>bouton du milieu</strong> de la souris et faites glisser pour vous déplacer. Maintenez <strong>Ctrl</strong> et faites défiler pour zoomer. Sur un trackpad, glissez à deux doigts.",
        "scroll": "molette"
      },
      "open": {
        "title": "Ouvrir un node",
        "body": "<strong>Double-cliquez</strong> sur un node pour l'ouvrir dans une fenêtre. Sélectionnez-le pour afficher sa barre d'outils, puis cliquez sur le crayon pour le modifier sur place.",
        "hint": "Double-clic"
      },
      "menu": {
        "title": "Le clic droit pour tout le reste",
        "body": "<strong>Faites un clic droit sur le canvas</strong> pour ajouter un node. <strong>Faites un clic droit sur un node ou une connexion</strong> pour changer sa couleur, le dupliquer ou le supprimer.",
        "hint": "Clic droit"
      }
    },
    "touch": {
      "navigate": {
        "title": "Se déplacer",
        "body": "Faites glisser <strong>un doigt</strong> pour vous déplacer. <strong>Pincez</strong> pour zoomer."
      },
      "open": {
        "title": "Ouvrir un node",
        "body": "<strong>Touchez deux fois</strong> un node pour l'ouvrir en plein écran."
      },
      "menu": {
        "title": "Ajouter et modifier",
        "body": "Touchez <strong>+</strong> dans la barre du bas pour ajouter un node. Sélectionnez un node pour le dupliquer ou le supprimer depuis cette même barre."
      }
    },
    "desktopFirst": {
      "title": "Idéal sur ordinateur",
      "body": "Nolënor est pensé pour un <strong>grand écran</strong>. Sur votre téléphone, c'est la vue compagnon : parcourez vos canvas, relisez vos nodes et posez vos questions à Nolë en déplacement. Pour profiter de tout, ouvrez Nolënor sur un ordinateur."
    }
  },
  "onboarding": {
    "promptPrefix": "Demandez à Nolë de ",
    "prompt": "Demandez à Nolë de {{task}}",
    "hints": {
      "appPrototype": {
        "label": "Prototype d'app",
        "suffix": "transformer des captures d'écran en prototype d'app mobile, avec un node modifiable par écran."
      },
      "imageGeneration": {
        "label": "Génération d'images",
        "suffix": "créer plusieurs variantes d'une image, en explorant différents styles et compositions."
      },
      "businessResearch": {
        "label": "Étude de marché",
        "suffix": "construire un lean canvas pour une idée de business, en étudiant son marché, ses concurrents et ses prix."
      },
      "csvVisualization": {
        "label": "Visualisation de CSV",
        "suffix": "analyser un CSV et mettre en images les enseignements les plus importants."
      },
      "projectWorkspace": {
        "label": "Espace projet",
        "suffix": "transformer des notes et des fichiers en espace de projet structuré, avec un résumé, les tâches clés et les prochaines étapes."
      },
      "productLaunch": {
        "label": "Lancement produit",
        "suffix": "préparer le lancement d'un produit, du positionnement aux 100 premiers clients."
      },
      "decisionSupport": {
        "label": "Aide à la décision",
        "suffix": "comparer des options, rechercher ce qui compte et m'aider à décider quoi faire ensuite."
      },
      "meetingNotes": {
        "label": "Notes de réunion",
        "suffix": "transformer des notes de réunion en décisions claires, avec responsables et prochaines étapes."
      }
    },
    "ideas": "Quelques idées pour commencer",
    "dictateTitle": "Dicter (ou maintenir Ctrl+Alt)",
    "stopDictation": "Arrêter la dictée",
    "startDictation": "Lancer la dictée",
    "uploading": "Import en cours — l'envoi sera possible une fois terminé",
    "holdToDictate": "Maintenez Ctrl+Alt pour dicter",
    "tapToDictate": "Touchez le micro pour dicter, touchez-le à nouveau pour arrêter",
    "listening": "Écoute…",
    "transcribing": "Transcription…",
    "heading": "Qu'avez-vous en tête ?",
    "subheading": "Un projet, des notes, des documents… Apportez-les ici. Nolë vous aide à y voir clair.",
    "startFromScratch": "Partir de zéro"
  },
  "dropzone": {
    "adding_one": "Ajout de {{done}}/{{count}} fichier…",
    "adding_other": "Ajout de {{done}}/{{count}} fichiers…",
    "readyWithFailures_one": "{{ready}}/{{count}} fichier prêt ({{failed}} en échec)",
    "readyWithFailures_other": "{{ready}}/{{count}} fichiers prêts ({{failed}} en échec)",
    "ready_one": "{{count}} fichier prêt sur le canvas",
    "ready_other": "{{count}} fichiers prêts sur le canvas",
    "moreMobile": "D'autres fichiers ? <browse>Parcourir les fichiers</browse>.",
    "moreDesktop": "D'autres fichiers ? Déposez-les ici ou <browse>parcourez</browse>.",
    "upload": "Importer des fichiers",
    "formats": "PDF, images, audio, liens, .csv, .md, .txt",
    "dropHere": "Déposez vos fichiers ici (PDF, images, audio, liens, .csv, .md, .txt)",
    "orBrowse": "ou <browse>parcourez vos fichiers</browse>"
  },
  "targetDelta": {
    "label": "Ce node est à environ {{screens}} écrans — la flèche indique sa direction"
  },
  "selectionResizer": {
    "saveFailed": "Impossible d'enregistrer la taille de la sélection"
  },
  "presence": {
    "hasItOpen": "l'a ouvert",
    "selectedIt": "l'a sélectionné"
  }
}
